<template>
<div>
  <div style="height: 40px;width: 500px;float: right;margin-top: -52px;">
    <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels range-separator="至" class="datePicker-query"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 360px">
    </el-date-picker>
    <el-button type="primary" @click="getTableHistoryHealthPerson">查询</el-button>
  </div>
  <div style="clear: both"></div>
  <div style="height: 530px;margin: 0 20px;overflow-y: auto">
    <el-row>
      <el-col :span="6" style="height: 530px;overflow-y: auto">
        <div style="height: 40px;line-height: 40px;font-size: 18px;color: #FFFFFF;margin-left: 10px;letter-spacing: 1px"><span>选择所想查看的指标历史曲线：</span></div>
        <div v-if="item.key_name !== '睡眠质量-浅睡' && item.key_name !== '睡眠质量-深睡'" v-for="(item, index) in typeSelectArr" :key="index" :class="item.isShow ? 'check-box' : 'check-box1'" @click="changeSelect(item)">{{item.key_name}}</div>
      </el-col>
      <el-col :span="18" style="height: 530px;overflow-y: auto">
        <div v-if="item.key_name !== '睡眠质量-浅睡' && item.key_name !== '睡眠质量-深睡'" class="list-card" v-for="(item, index) in healthTypeList" :key="index">
          <div class="flex-card">
            <div class="flex-left">
              <div class="flex-type">{{ item.key_name }}</div>
              <div class="flex-content">
                <div class="num-line">
                  <span v-if="item.key_name === '血压'" style="color: #36a3ff">{{ item.xueya1 }} / {{ item.xueya2 }}</span>
                  <span v-else style="color: #36a3ff">{{ item.keyVal }}</span>
                  <span v-if="item.key_name === '体温'" style="color: #b6b6b6;font-size: 18px">°C</span>
                </div>
                <div class="color-line">
                  <div v-if="item.key_name === '体温'">
                    <div style="height: 13px;padding-top: 10px;">
                      <div :style="{marginLeft: item.keyVal === '-' ? '0%' : item.keyVal + '%'}" class="triangle-gray"></div>
                    </div>
                    <div style="margin: 0 5px">
                      <el-row>
                        <el-col :span="4"><div style="background-image: linear-gradient(#317cfc, #317cfc), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        <el-col :span="7"><div style="background-image: linear-gradient(#53bbbd, #53bbbd), linear-gradient(#32b16c, #32b16c);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        <el-col :span="13"><div style="background-image: linear-gradient(#fb651f, #fb651f), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                      </el-row>
                    </div>
                  </div>
                  <div v-if="item.key_name === '血压'">
                    <div style="height: 13px;padding-top: 10px;">
                      <div :style="{marginLeft: item.valPec}" class="triangle-gray"></div>
                    </div>
                    <div style="margin: 0 5px">
                      <el-row>
                        <el-col :span="4"><div style="background-image: linear-gradient(#5ea0fc, #5ea0fc), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        <el-col :span="4"><div style="background-image: linear-gradient(#65ba5c, #65ba5c), linear-gradient(#32b16c, #32b16c);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        <el-col :span="4"><div style="background-image: linear-gradient(#fec61f, #fec61f), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        <el-col :span="4"><div style="background-image: linear-gradient(#fe9803, #fe9803), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        <el-col :span="4"><div style="background-image: linear-gradient(#fe7701, #fe7701), linear-gradient(#32b16c, #32b16c);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                        <el-col :span="4"><div style="background-image: linear-gradient(#db4245, #db4245), linear-gradient(#00b7ee, #00b7ee);background-blend-mode: normal, normal;" class="item-div"></div></el-col>
                      </el-row>
                    </div>
                  </div>
                  <div v-if="item.key_name === '血糖'">
                    <div style="height: 13px;padding-top: 10px;">
                      <div :style="{marginLeft: item.valPec}" class="triangle-gray"></div>
                    </div>
                    <div style="margin: 0 5px">
                      <el-row>
                        <el-col :span="4"><div style="background-color: #db4245" class="item-div"></div></el-col>
                        <el-col :span="14"><div style="background-color: #16f0e3" class="item-div"></div></el-col>
                        <el-col :span="6"><div style="background-color: #fe9803" class="item-div"></div></el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-time">测量时间：{{ item.showTime }}</div>
            </div>
            <div class="flex-right">
              <div style="height:100%;width: 100%" :ref="item.wrap"></div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {queryhealthquerypersonhistory} from '../../../api/yanglaoyuan'

export default {
  name: 'historyListShow',
  props: {
    healthObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      healthdatatype: [],
      personHealthRow: '',
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
        // shortcuts: []
      },
      tableDataHistory: [], // 历史所以数据
      typeList: [],
      xueya: '',
      healthTypeList: [
        // {id: 3, keyVal: 80, key_name: '血压', yData1: [80, 88, 86, 82, 85], yData2: [60, 77, 66, 75, 70], xData: ['1.2', '1.3', '1.4', '1.5', '1.6'], wrap: 'wrap_3'},
        // {id: 1, keyVal: 37, key_name: '体温', yData: [36, 36.2, 37, 35.5, 35.2], xData: ['1.2', '1.3', '1.4', '1.5', '1.6'], wrap: 'wrap_1'},
        // {id: 2, keyVal: 80, key_name: '心率', yData: [80, 88, 86, 82, 85], xData: ['1.2', '1.3', '1.4', '1.5', '1.6'], wrap: 'wrap_2'}
      ],
      typeSelectArr: []
    }
  },
  created () {
    this.healthdatatype = this.healthObj.healthdatatype // 健康类型
    this.personHealthRow = this.healthObj.personHealthRow // 老人最新数据
    console.log(this.healthObj)
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-7)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
  },
  mounted () {
    this.getTypeList()
  },
  methods: {
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      // console.log('endDate', endDate)
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    getTypeList () {
      let arr = []
      // let vm = this
      let personHealth = this.clone(this.personHealthRow.person_health_value)
      let healthType = this.clone(this.healthdatatype)
      let xueya = {
        id: 0,
        gaoId: '',
        diId: '',
        key_name: '血压',
        keyVal: '',
        xueya1: this.personHealthRow.xueya1,
        xueya2: this.personHealthRow.xueya2,
        valPec: this.personHealthRow.valPec,
        showTime: '-',
        wrap: 'wrap_xueya',
        yData1: [], // 高
        yData2: [], // 低
        xData: [],
        isShow: true
      }
      for (let i = 0; i < healthType.length; i++) {
        if (healthType[i].key_name === '血压-高压') {
          xueya.gaoId = healthType[i].id
          personHealth.forEach(item => {
            if (item.health_key_id === healthType[i].id) {
              xueya.showTime = item.create_time
            }
          })
        } else if (healthType[i].key_name === '血压-低压') {
          xueya.diId = healthType[i].id
        } else if (healthType[i].key_name === '心率' || healthType[i].key_name === '血糖' || healthType[i].key_name === '血氧' ||
          healthType[i].key_name === '体温' || healthType[i].key_name === '睡眠质量-浅睡' || healthType[i].key_name === '睡眠质量-深睡') {
          let obj = healthType[i]
          obj.wrap = 'wrap_' + obj.id
          // 最新数据
          obj.valPec = '0%' // 血压 血糖
          obj.keyVal = '-'
          obj.showTime = '-'
          personHealth.forEach(item => {
            if (obj.id === item.health_key_id) {
              if (parseFloat(item.health_value)) {
                obj.keyVal = parseFloat(item.health_value)
                obj.showTime = item.create_time
              }
            }
          })
          if (obj.key_name === '血糖') {
            obj.valPec = this.personHealthRow.valxuetang
          }
          obj.xData = []
          obj.yData = []
          obj.isShow = true
          arr.push(obj)
        }
      }
      arr.push(xueya)
      this.xueya = xueya
      this.typeList = arr
      this.typeSelectArr = arr
      console.log(990, arr)
      this.getTableHistoryHealthPerson()
    },
    getTableHistoryHealthPerson () {
      this.healthTypeList = []
      let params = {
        size: 9999,
        page: 1
      }
      let pid = 0
      if (this.$store.state.user.moduletag === 2) {
        pid = this.personHealthRow.epid === '' ? 0 : this.personHealthRow.epid
      } else {
        pid = this.personHealthRow.pid === '' ? 0 : this.personHealthRow.pid
      }

      let data = {
        'epid': pid,
        'pid': pid,
        'from': this.sendDate[0] + ' 00:00:00',
        'to': this.sendDate[1] + ' 23:59:59',
        'eid': this.$store.state.user.LoginResp.entity_id
      }
      queryhealthquerypersonhistory(params, data).then(res => {
        this.tableDataHistory = res.data.healthdata
        this.getDataEnd()
      })
    },
    changeSelect (item) {
      let arr = []
      for (let i = 0; i < this.typeSelectArr.length; i++) {
        if (item.key_name === this.typeSelectArr[i].key_name) {
          this.typeSelectArr[i].isShow = !this.typeSelectArr[i].isShow
        }
        if (this.typeSelectArr[i].isShow) {
          arr.push(this.typeSelectArr[i])
        }
      }
      this.typeList = arr
      this.getDataEnd()
    },
    getDataEnd () {
      let vm = this
      let xueyatime = []
      let xueya1 = []
      let xueya2 = []
      this.tableDataHistory.forEach(item => {
        if (item.health_key_id === vm.xueya.gaoId) {
          xueyatime.push(item.create_time)
          if (parseFloat(item.health_value)) {
            xueya1.push(parseFloat(item.health_value))
          } else {
            xueya1.push('')
          }
        } else if (item.health_key_id === vm.xueya.diId) {
          xueya2.push(item)
        }
      })
      let arr = this.typeList
      let arrEnd = []
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        // 历史表图
        if (obj.key_name === '血压') {
          obj.xData = xueyatime
          obj.yData1 = xueya1
          let y2 = []
          xueyatime.forEach(item => {
            let di = ''
            xueya2.forEach(val2 => {
              if (val2.create_time === item) {
                if (parseFloat(val2.health_value)) {
                  di = parseFloat(val2.health_value)
                }
              }
            })
            y2.push(di)
          })
          obj.yData2 = y2
        } else {
          let x = []
          let y = []
          this.tableDataHistory.forEach(item => {
            if (obj.id === item.health_key_id) {
              if (parseFloat(item.health_value)) {
                y.push(parseFloat(item.health_value))
                x.push(item.create_time)
              }
            }
          })
          obj.xData = x
          obj.yData = y
        }
        arrEnd.push(obj)
      }
      this.healthTypeList = arrEnd
      console.log(1122, arrEnd)
      setTimeout(() => {
        vm.getChartArr()
      }, 1500)
    },
    getChartArr () {
      for (let i = 0; i < this.healthTypeList.length; i++) {
        // console.log('wrap', this.healthTypeList[i].key_name, this.healthTypeList[i].wrap)
        if (this.healthTypeList[i].key_name === '血压') {
          // console.log(i, this.healthTypeList[i].key_name)
          this.initCharts1(this.healthTypeList[i].xData, this.healthTypeList[i].yData1, this.healthTypeList[i].yData2, this.healthTypeList[i].wrap)
        } else {
          // console.log(i, this.healthTypeList[i].key_name)
          if (this.healthTypeList[i].key_name !== '睡眠质量-浅睡' && this.healthTypeList[i].key_name !== '睡眠质量-深睡') {
            this.initCharts(this.healthTypeList[i].xData, this.healthTypeList[i].yData, this.healthTypeList[i].wrap)
          }
        }
      }
    },
    initCharts (xData, yData, wrap) {
      // console.log(445, this.$refs[wrap])
      let chart = this.$echarts.init(this.$refs[wrap][0])
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: [{ right: '5%', top: '10%', bottom: '15%' }],
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#34B8FF',
              width: 1
            }
          },
          data: xData
        },
        yAxis: {
          splitLine: { // 修改背景线条样式
            show: true, // 是否展示
            lineStyle: {
              color: '#34B8FF' // 线条颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: '#34B8FF',
              width: 1 // 这里是为了突出显示加上的
            }
          },
          type: 'value'
        },
        series: [
          { data: yData, type: 'line' }
        ],
        color: ['#39FFD1']
      })
    },
    initCharts1 (xData, yData1, yData2, wrap) {
      // console.log(223, wrap)
      let chart = this.$echarts.init(this.$refs[wrap][0])
      chart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['高压', '低压'], textStyle: { color: '#ffffff' } },
        grid: [{ right: '5%', top: '10%', bottom: '15%' }],
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#34B8FF',
              width: 1
            }
          },
          boundaryGap: false,
          data: xData
        },
        yAxis: {
          splitLine: { // 修改背景线条样式
            show: true, // 是否展示
            lineStyle: {
              color: '#34B8FF' // 线条颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: '#34B8FF',
              width: 1 // 这里是为了突出显示加上的
            }
          },
          type: 'value'
        },
        series: [
          { name: '高压', type: 'line', data: yData1 },
          { name: '低压', type: 'line', data: yData2 }
        ],
        color: ['#d2ab27', '#27cb7c']
      })
    }
  }
}
</script>

<style scoped>
.list-card{
  height: 280px;
  background: #152F5D;
  margin: 10px;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #34B8FF;
}
.flex-card{
  display: flex;height: 250px;margin: 15px;
}
.flex-left{
  width: 250px;height: 250px
}
.flex-right{
  flex: 1;height: 250px;border-left: 1px solid #BFBFBF;
}
.flex-type{
  height: 40px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #ffffff;
}
.flex-content{
  height: 170px;
}
.num-line{
  height: 60px;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  padding-top: 45px;
}
.color-line{
  height: 50px;margin-right: 15px;
}
.triangle-gray{
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 8px solid #d1d1d1;
}
.item-div{
  height: 8px;
  border-radius: 4px;
  margin: 0 2px;
}
.flex-time{
  height: 40px;
  font-family: PingFang-SC-Bold;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 41px;
  letter-spacing: 1px;
  color: #999999;
  text-align: center;
}
.check-box{
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 19px;
  color: #FFFFFF;
  background: #15425B;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #34B8FF;
  float: left;
  margin: 10px;
  cursor: pointer;
}
.check-box1{
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 19px;
  color: #FFFFFF;
  background: #152F5D;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #152F5D;
  float: left;
  margin: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/historyListShow.vue